import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingSpinner = ({ size = 24 }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" p={1}>
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingSpinner; 